import {
  BessOperatingIncomeResult,
  IsoBa,
  SystemConfigurations
} from '@/interfaces'
import { formatters } from '@/utils'

export const useScenarioResultsSummaryTabAdjustableTableConfig = (
  isoType?: IsoBa,
  systemConfiguration?: SystemConfigurations,
  results?: BessOperatingIncomeResult[]
) => {
  const isSpain = isoType === IsoBa.ES_PENINSULA

  switch (systemConfiguration) {
    case SystemConfigurations.Standalone:
      return isSpain
        ? {
            header: {
              gridColumnTemplate: '1fr 4fr 4fr',
              columns: [
                { label: '' },
                { label: 'BESS operating income summary' },
                { label: 'BESS operating income by market product' }
              ]
            },
            columnNames: [
              'Year',
              'Usable Energy at POI (MWh)',
              'Equivalent Full Cycles',
              'Total ES Income (€)',
              'Total ES Income (€/kW-mo)',
              'DAM Energy (€)',
              'aFRR Power (€)',
              'aFRR Energy (€)',
              'mFRR Energy (€)'
            ],
            rows: results?.map(item => [
              item.year.toFixed(0),
              formatters.number(item.usableEnergyAtPoi) ?? '-',
              formatters.number(item.equivalentFullCycles) ?? '-',
              formatters.number(item.esOnlyIncome) ?? '-',
              formatters.number(item.totalEsIncomeKw) ?? '-',
              formatters.number(item.damEnergy) ?? '-',
              formatters.number(item.aFrrPower) ?? '-',
              formatters.number(item.aFrrEnergy) ?? '-',
              formatters.number(item.mFrrEnergy) ?? '-'
            ])
          }
        : {
            header: {
              gridColumnTemplate: '1fr 4fr 5fr',
              columns: [
                { label: '' },
                { label: 'BESS operating income summary' },
                { label: 'BESS operating income by market product' }
              ]
            },
            columnNames: [
              'Year',
              'Usable Energy at POI (MWh)',
              'Equivalent Full Cycles',
              'Total ES Income ($)',
              'Total ES Income ($/kW-mo)',
              'DAM Energy ($)',
              'RTM Energy ($)',
              'DAM Reg Up ($)',
              'DAM Reg Down ($)',
              'DAM SR ($)'
            ],
            rows: results?.map(item => [
              item.year.toFixed(0),
              formatters.number(item.usableEnergyAtPoi) ?? '-',
              formatters.number(item.equivalentFullCycles) ?? '-',
              formatters.number(item.esOnlyIncome) ?? '-',
              formatters.number(item.totalEsIncomeKw) ?? '-',
              formatters.number(item.damEnergy) ?? '-',
              formatters.number(item.rtmEnergy) ?? '-',
              formatters.number(item.damRegUp) ?? '-',
              formatters.number(item.damRegDown) ?? '-',
              formatters.number(item.damSr) ?? '-'
            ])
          }
    case SystemConfigurations.SolarPV:
    case SystemConfigurations.WindOnShareBus:
    case SystemConfigurations.SolarPVOnSharedBus:
      return isSpain
        ? {
            header: {
              gridColumnTemplate: '1fr 1fr 1fr 4fr 5fr',
              columns: [
                { label: '' },
                { label: 'PV + ES' },
                { label: 'PV' },
                { label: 'BESS operating income summary' },
                { label: 'BESS operating income by market product' }
              ]
            },
            columnNames: [
              'Year',
              'PV+ES Income (€)',
              'Income w/o ES (€)',
              'Usable Energy at POI (MWh)',
              'Equivalent Full Cycles',
              'Total ES Income (€)',
              'Total ES Income (€/kW-mo)',
              'PV Revenue Loss (€)',
              'DAM Energy (€)',
              'aFRR Power (€)',
              'aFRR Energy (€)',
              'mFRR Energy (€)'
            ],
            rows: results?.map(item => [
              item.year.toFixed(0),
              formatters.number(item.totalIncome) ?? '-',
              formatters.number(item.pvOnlyIncome) ?? '-',
              formatters.number(item.usableEnergyAtPoi) ?? '-',
              formatters.number(item.equivalentFullCycles) ?? '-',
              formatters.number(item.esOnlyIncome) ?? '-',
              formatters.number(item.totalEsIncomeKw) ?? '-',
              formatters.number(item.pvRevenueLoss) ?? '-',
              formatters.number(item.damEnergy) ?? '-',
              formatters.number(item.aFrrPower) ?? '-',
              formatters.number(item.aFrrEnergy) ?? '-',
              formatters.number(item.mFrrEnergy) ?? '-'
            ])
          }
        : {
            header: {
              gridColumnTemplate: '1fr 1fr 1fr 4fr 6fr',
              columns: [
                { label: '' },
                { label: 'PV + ES' },
                { label: 'PV' },
                { label: 'BESS operating income summary' },
                { label: 'BESS operating income by market product' }
              ]
            },
            columnNames: [
              'Year',
              'PV+ES Income ($)',
              'Income w/o ES ($)',
              'Usable Energy at POI (MWh)',
              'Equivalent Full Cycles',
              'Total ES Income ($)',
              'Total ES Income ($/kW-mo)',
              'PV Revenue Loss ($)',
              'DAM Energy ($)',
              'RTM Energy ($)',
              'DAM Reg Up ($)',
              'DAM Reg Down ($)',
              'DAM SR ($)'
            ],
            rows: results?.map(item => [
              item.year.toFixed(0),
              formatters.number(item.totalIncome) ?? '-',
              formatters.number(item.pvOnlyIncome) ?? '-',
              formatters.number(item.usableEnergyAtPoi) ?? '-',
              formatters.number(item.equivalentFullCycles) ?? '-',
              formatters.number(item.esOnlyIncome) ?? '-',
              formatters.number(item.totalEsIncomeKw) ?? '-',
              formatters.number(item.pvRevenueLoss) ?? '-',
              formatters.number(item.damEnergy) ?? '-',
              formatters.number(item.rtmEnergy) ?? '-',
              formatters.number(item.damRegUp) ?? '-',
              formatters.number(item.damRegDown) ?? '-',
              formatters.number(item.damSr) ?? '-'
            ])
          }
    default:
      return {
        header: {},
        columnNames: [],
        rows: []
      }
  }
}
